<template>
  <div>
    <!-- 기본정보 -->
    <field-select-module v-model="form.stdInfo" :board="this.board" :is-print="isPrint" />

    <!-- 사진대지 -->
    <photo-upload-grid-module :row-count="2" :grid-count="2" v-model="form.photoList1" :isPrint="isPrint" :readonly="board.readonly" section-title="조치 전 사진" placeholder="점검 현장 사진" class="mt-28px" />

    <photo-upload-grid-module :row-count="2" :grid-count="2" v-model="form.photoList2" :isPrint="isPrint" :readonly="board.readonly" section-title="조치 후 사진" placeholder="점검 현장 사진" class="mt-28px" />

    <div class="mt-28px">
      <div class="writeGridContainer mt-4">
        <div>
          <div>작업환경측정 결과 근로자 공지 여부</div>
          <p v-if="isPrint" class="print-input">{{ form.inputA_9 }}</p>
          <div v-else>
            <vs-radio v-model="form.inputA_9" :disabled="board.readonly" vs-value="공지" vs-name="공지여부" class="mr-4">공지</vs-radio>
            <vs-radio v-model="form.inputA_9" :disabled="board.readonly" vs-value="비공지" vs-name="공지여부" class="mr-4">비공지</vs-radio>
          </div>
        </div>
      </div>
    </div>

    <!-- 파일첨부 -->
    <file-upload-module id="fileList" class="mt-28px" v-model="form.fileList" :is-print="isPrint" :readonly="board.readonly"></file-upload-module>
  </div>
</template>

<script>
import FieldSelectModule from "@/views/modules/FieldSelectModule";
import PhotoUploadGridModule from "@/views/modules/PhotoUploadGridModule";
import FileUploadModule from "@/views/modules/FileUploadModule";

export default {
  components: {
    FieldSelectModule,
    PhotoUploadGridModule,
    FileUploadModule,
  },
  props: {
    isPrint: Boolean,
    board: Object,
    value: Object,
  },
  watch: {
    value: {
      immediate: true,
      deep: true,
      handler(value) {
        const keys = Object.keys(this.form);
        for (const key of keys) {
          if (value[key]) {
            this.form[key] = value[key];
          }
        }
      },
    },
    form: {
      immediate: true,
      deep: true,
      handler(value) {
        value.title = this.board.writer.department;
        this.$emit("input", value);
      },
    },
  },
  methods: {},
  data() {
    return {
      form: {
        stdInfo: {},

        inputA_9: "",

        fileList: [],
        photoList1: [],
        photoList2: [],
      },
    };
  },
};
</script>
